import React, { Component } from "react";
import { connect } from "react-redux";
import { loadCartByUrl } from "../actions/cartActions";
import { withRouter } from "react-router";
import { utils } from "../common/utils";
import { withTranslation } from 'react-i18next';
import Cart from "./Cart";
import Alert from "../components/Alert";

class CartDetails extends Component {

    state = { selectedCart: null };

    componentDidMount() {
        const { cartUrl } = this.props;

        this.props.loadCartByUrl(cartUrl).then((response) => {
            let cart = response.value.data;
            if (cart) {
                cart.lines = JSON.parse(cart.cartJson);
                this.setState({
                    selectedCart: cart
                });
            } 
            utils.scrollTop();
        }, (error) => {
            console.log(error)
        });
    }

    render() {
        const { selectedCart } = this.state;

        const { t } = this.props;
        if (!selectedCart )
             return <Alert type="info" title={t("View Cart")} msg={t("Sorry, Cart is not available")} />;;

        return (
            <Cart isReadOnly={true} showCartShareActions={true} selectedCart={selectedCart} />
        );
    }
}

function mapStateToProps({  }, ownProps) {
    return { ...ownProps };
}

export default withTranslation()(withRouter(
    connect(mapStateToProps, {  loadCartByUrl })(CartDetails))
);
